<template>
  <div
    class="foreign-offer-lot width-100"
    :data-qa="`foreign-offer.lots[${index}]`">
    <div
      class="flex align-center width-100">
      <sFormItem
        :label="$t('Tenders.ChooseLot')"
        :prop="`lots[${index}].lotId`"
        style="min-width: 430px;">
        <sSelect
          class="width-100"
          data-qa="offer-lot"
          :disabled="disabled || (lot_sync.bid && !!lot_sync.bid.id)"
          filterable
          :placeholder="$t('Tenders.ChooseLot')"
          popper-class="foreign-offer-select-lot"
          :value.sync="lot_sync.tender_lot"
          value-key="lotId"
          @update:value="selectLot">
          <sOption
            v-for="item in available_lots"
            :key="`lot-${item.lotId}`"
            :data-qa="`lot-${item.lotId}`"
            :label="item.title"
            :value="item"/>
        </sSelect>
      </sFormItem>
      <sButton
        v-if="index || lots_count > 1"
        data-qa="delete-offer-lot"
        :disabled="disabled"
        icon="delete"
        type="text"
        @click="deleteLot"/>
    </div>

    <div
      v-if="lot_sync.tender_lot.lotId">
      <div class="flex flex-between">
        <!-- todo external без ПДВ - признак з тендера -->
        <sFormItem
          ref="lot_price"
          class="width-55"
          :label="price_label"
          :prop="`lots[${index}].price`">
          <sInput-number
            :disabled="disabled"
            :value.sync="lot_sync.price"/>
        </sFormItem>
        <sFormItem
          ref="lot_quantity"
          class="width-35"
          :label="`${$t('Catalog.Amount')}, (${unit})`"
          :prop="`lots[${index}].quantity`">
          <sInput-number
            :disabled="disabled"
            :precision="3"
            :value.sync="lot_sync.quantity"/>
        </sFormItem>
      </div>

      <template
        v-if="lot_sync.criteria && lot_sync.criteria.length">
        <sDivider class="mb-4"/>
        <OfferCriterion
          v-for="(item, i) in lot_sync.criteria"
          :key="item.criterion.id"
          :all_criteria="lot_sync.criteria.concat(tender_criteria)"
          :criterion="item.criterion"
          :disabled="disabled"
          :form_prop="`lots[${index}].criteria[${i}].value`"
          :value.sync="item.value"/>
        <div
          v-if="lot_sync.criteria && lot_sync.criteria.length"
          class="flex flex-between mb-4">
          <sButton
            small
            @click="copyCriteria(false)">
            {{ $t('Common.CopyToEmpty') }}
          </sButton>
          <sButton
            small
            @click="copyCriteria(true)">
            {{ $t('Common.CopyToAll') }}
          </sButton>
        </div>
      </template>
      <sFormItem
        class="width-100"
        :label="$t('Tenders.LotAdditionalInformation')"
        :prop="`lots[${index}].comment`">
        <sInput
          clearable
          data-qa="lot-comment"
          :disabled="disabled"
          :max-length="4000"
          max-rows="20"
          :placeholder="$t('Tenders.ParticipantInfo')"
          rows="1"
          type="textarea"
          :value.sync="lot_sync.comment"/>
      </sFormItem>
    </div>
  </div>
</template>
<script>
import OfferCriterion from 'components/tenders/tender page/foreign offer/OfferCriterion.vue'

export default {
  name: 'foreignOfferLot',
  props: {
    index: {
      type: Number,
    },
    lot: {
      type: Object,
    },
    lots: {
      type: Array,
    },
    lots_count: {
      type: Number,
    },
    currency: {
      type: [String, Object],
    },
    tender_criteria: {
      type: Array,
    },
    vatInclude: Boolean,
    disabled: Boolean,
  },
  created() {
  },
  computed: {
    curr_title() {
      return this.currency.title || this.currency || this.$t('Tenders.Unit').slice(0,2)
    },
    unit() {
      return this.lot_sync.tender_lot?.unit?.title || this.$t('Tenders.Unit').slice(0,2)
    },
    price_label() {
      let vat = this.vatInclude ? this.$t('Tenders.WithVAT') : this.$t('Tenders.WithoutVAT')
      return `${this.$t('Catalog.Price')}, ${this.curr_title} ${this.$t('Common.Per')} 1 (${this.unit}) ${ vat }`
    },
    available_lots() {
      return this.lot_sync.tender_lot.lotId ? [this.lot_sync.tender_lot].concat(this.lots) : this.lots
    },
    lot_sync: {
      get() {
        return this.lot
      },
      set(value) {
        this.$emit('update:lot', value )
      }
    }

  },
  methods: {
    copyCriteria(copyToAll) {
      this.$emit('copyCriteria', {all: copyToAll, criteria: this.lot_sync.criteria})
    },
    deleteLot() {
      this.$emit('deleteLot', this.lot_sync.lotId, this.index)
    },
    selectLot(val) {
      this.$set(this.lot_sync, 'lotId', val.lotId )
      this.$set(this.lot_sync, 'price', val.price )
      this.$set(this.lot_sync, 'quantity', val.quantity )

    }
  },
  components: {
    OfferCriterion
  }
}
</script>
<style lang="scss">
.foreign-offer-select-lot {
  max-width: 430px;
}
</style>
